import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Split Packed Bubble chart type
 * Extends the base configuration
 * Requires the highcharts-more module
 */
export const splitbubbleChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'packedbubble'
    },
    title: {
        text: undefined
    },
    tooltip: {
        useHTML: true,
        pointFormat: '<b>{point.name}:</b> {point.value}'
    },
    plotOptions: {
        packedbubble: {
            minSize: '30%',
            maxSize: '120%',
            zMin: 0,
            zMax: 1000,
            // Split layout configuration
            layoutAlgorithm: {
                splitSeries: true,
                gravitationalConstant: 0.02,
                seriesInteraction: false,
                dragBetweenSeries: true,
                parentNodeLimit: true
            },
            dataLabels: {
                enabled: true,
                format: '{point.name}',
                filter: {
                    property: 'y',
                    operator: '>',
                    value: 250
                },
                style: {
                    color: 'black',
                    textOutline: 'none',
                    fontWeight: 'normal'
                }
            }
        }
    },
    // For split packed bubble charts, we typically don't need axes
    xAxis: {
        visible: false
    },
    yAxis: {
        visible: false
    },
    // Specific series configuration for split bubbles
    series: [
        {
            name: 'Group 1',
            data: []
        },
        {
            name: 'Group 2',
            data: []
        },
        {
            name: 'Group 3',
            data: []
        }
    ]
} as unknown as Options);
